<template>
    <component :is="currentComponent" />
</template>

<script>
import XigCheckHomePC from './XigCheckHomePC.vue'
import XigCheckHomeMobile from './XigCheckHomeMobile.vue'

export default {
    name: 'XigCheckHome',
    components: {
        XigCheckHomePC,
        XigCheckHomeMobile
    },
    data() {
        return {
            isMobile: false
        }
    },
    computed: {
        currentComponent() {
            return this.isMobile ? 'XigCheckHomeMobile' : 'XigCheckHomePC'
        }
    },
    mounted() {
        this.checkMobile()
        window.addEventListener('resize', this.checkMobile)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile)
    },
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth <= 900
        }
    }
}
</script>
